import { EnvironmentProviders, Provider, inject, provideEnvironmentInitializer } from '@angular/core';
import { AuthService } from './auth.service';

export const provideAuth = (): Array<Provider | EnvironmentProviders> => {
  return [
    provideEnvironmentInitializer(() => {
      inject(AuthService);
    })
  ];
};
